namespace $ { $mol_style_attach( "mol/svg/text/text.view.css",
 "[mol_svg_text] {\n\tfill: currentColor;\n\tstroke: none;\n}\n"
) }